import React, { Component } from 'react';
import { Table, Button } from 'antd';
import SeepageModal from './SeepageModal';
import { FooterLabel, VLabel } from './style';

const Fragment = React.Fragment;

export default class extends Component {
  state = {
    isModalActive: false,
  };

  toggerModal = () => {
    this.setState({ isModalActive: !this.state.isModalActive });
  };

  openModal = (record) => {
    this.setState({ isModalActive: !this.state.isModalActive, record });
  };

  seepageTable = ({ seepage, frameIndex }) => {
    let totalQ = 0;
    const dataList = seepage.data[frameIndex].value;

    const columns = [
      {
        title: 'รทก.',
        dataIndex: 'level',
        key: 'level',
      },
      {
        title: 'Factor of Safety',
        dataIndex: 'fs',
        key: 'fs',
      },
      {
        title: 'Piping',
        dataIndex: 'piping',
        key: 'piping',
      },
      {
        title: 'q',
        dataIndex: 'q',
        key: 'q',
      },
      {
        title: 'V',
        key: 'v',
        render: (text, record) => (
          <VLabel critical={record.v >= this.props.seepageProfile.Vc}>{record.v}</VLabel>
        ),
      },
      {
        title: '#',
        key: 'action',
        render: (text, record) => (
          <Button onClick={() => this.openModal(record)}>
            <i className="far fa-chart-bar"></i> More
          </Button>
        ),
      },
    ];

    const dataSource = Object.keys(dataList).reduce((result, index) => {
      const { v, piping, fs, q, ...other } = dataList[index];
      totalQ += q;

      result.push({
        level: index,
        v: v.toFixed(6),
        piping: piping.toFixed(6),
        fs: fs.toFixed(6),
        q: q.toFixed(6),
        ...other,
      });
      return result;
    }, []);

    return {
      dataSource,
      columns,
      totalQ,
    };
  };

  render() {
    const { seepage, frameIndex, seepageProfile } = this.props;
    const { isModalActive, ...modalInfo } = this.state;
    const { dataSource, columns, totalQ } = this.seepageTable({ seepage, frameIndex });

    return (
      <Fragment>
        <div className="row">
          <div className="col-sm-8 col-sm-offset-2">
            <Table dataSource={dataSource} columns={columns} pagination={false} />
            <FooterLabel>
              <strong>Vc</strong>: {seepageProfile.Vc}
              &nbsp; &nbsp;
              <strong>Q</strong>: {Number(totalQ).toFixed(6)}
            </FooterLabel>
          </div>
        </div>
        {isModalActive && (
          <SeepageModal closeModal={this.toggerModal} Vc={seepageProfile.Vc} {...modalInfo} />
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/SeepageSection/index.js